module.exports = __webpack_public_path__ + "media/ToolBox.866ab178.mp4";